import React from 'react';
import { LocaleText, LocaleTemplate } from '../../i18n/Locale';

// Only scanner-owned status/reason text enters here, never agent prose or identities.
const catalogue = /^CoinGecko catalogue checked: ([\d,]+)\/([\d,]+)\. Market-screened: ([\d,]+); missing\/stale\/invalid: ([\d,]+); unqueried: ([\d,]+)\. ([\s\S]+)$/;
const unavailable = 'Asset classification unavailable; no AI review requested. ';

export const ScannerText = ({ value }) => {
  const match = typeof value === 'string' ? value.match(catalogue) : null;
  if (match) return <><LocaleTemplate message="CoinGecko catalogue checked: {0}/{1}. Market-screened: {2}; missing/stale/invalid: {3}; unqueried: {4}." values={match.slice(1,6)} />{' '}<ScannerText value={match[6]} /></>;
  if (typeof value === 'string' && value.startsWith(unavailable)) return <><LocaleText value={unavailable} /><LocaleText value={value.slice(unavailable.length)} /></>;
  return <LocaleText value={value} />;
};